var _path, _path2, _ellipse, _ellipse2, _path3, _ellipse3, _ellipse4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfterpressed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 260,
    viewBox: "0 0 282 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 13.4315 13.4315 0 30 0H228.14C242.079 0 254.182 9.6003 257.353 23.1732L279.947 119.852C280.969 124.228 280.996 128.778 280.024 133.165L257.145 236.486C254.103 250.223 241.924 260 227.854 260H30C13.4315 260 0 246.569 0 230V30Z",
    fill: "#FFBB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 13.4315 13.4315 0 30 0H228.14C242.079 0 254.182 9.6003 257.353 23.1732L279.947 119.852C280.969 124.228 280.996 128.778 280.024 133.165L257.145 236.486C254.103 250.223 241.924 260 227.854 260H30C13.4315 260 0 246.569 0 230V30Z",
    fill: "url(#paint0_linear_26_29)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 172.829,
    cy: 103.48,
    rx: 37.7907,
    ry: 39,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 183,
    cy: 104,
    rx: 13,
    ry: 14,
    fill: "#030303"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51 187C79.0141 165.837 137.558 135.293 206 184.382",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.7907,
    cy: 107,
    rx: 37.7907,
    ry: 39,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.9612,
    cy: 107.52,
    rx: 13,
    ry: 14,
    fill: "#030303"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_29",
    x1: 200.5,
    y1: 138,
    x2: 505,
    y2: 139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF2115",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterpressed);
export default __webpack_public_path__ + "static/media/afterpressed.b1d7b3768d5d3a1d414fbb8260908069.svg";
export { ForwardRef as ReactComponent };